<template>
    <div>
        <page-header >
            <template #breadcrumbs>
                <router-link to="/analytics">Аналитика</router-link> &raquo; Поставщики услуг
            </template>
            <h2>Поставщики услуг</h2>
        </page-header>
        <div>
            <ul class="nav nav-tabs nav-justified">
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('tabOrgCapacities')" :class="{ active: isActive('tabOrgCapacities') }" href="#tabOrgCapacities">Мощности организаций</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('tabSpecialists')" :class="{ active: isActive('tabSpecialists') }" href="#tabSpecialists">Специалисты</a>
                </li>
            </ul>
        </div>
        <div class="tab-content mt-4" id="myTabContent">
            <div class="tab-pane fade" :class="{ 'active show': isActive('tabOrgCapacities') }" id="tabOrgCapacities">
                <section class="content">
                    <report-org-capacity-filter
                            v-bind:filters="orgCapacityRptFilter"
                            v-on:apply="onFiltersApply($event)"
                            v-on:reset="onFiltersReset($event)"
                            v-on:exportReport="exportReportOrgCapacity($event)"
                    />
                    <div class="table-inner mb-4" v-if="reportOrgCapacity">
                        <table class="table-custom">
                            <thead>
                            <tr>
                                <th v-for="(hdr, index) in reportOrgCapacity.header">{{hdr.title}}
                                  <i style="cursor: pointer" @click="columnSort(index, 'reportOrgCapacity')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': sortMode && index === idx, 'text-black': index === idx}"></i></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in reportOrgCapacity.data">
                                <td v-for="(hdr, index) in reportOrgCapacity.header">
                                    {{item.values[index]}}
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td v-for="val in reportOrgCapacity.summary[0].values">
                                    {{val}}
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </section>
            </div>
            <div class="tab-pane fade" :class="{ 'active show': isActive('tabSpecialists') }" id="tabSpecialists">
                <section class="content">
                    <report-specialists-filter
                            v-bind:filters="specialistsRptFilter"
                            v-on:apply="onFiltersApply($event)"
                            v-on:reset="onFiltersReset($event)"
                            v-on:exportReport="exportReportSpecialists($event)"
                    />
                    <div class="table-inner mb-4" v-if="reportSpecialists">
                        <table class="table-custom special">
                            <thead>
                            <tr>
                                <th v-for="(hdr, index) in reportSpecialists.header">{{hdr.title}}
                                  <i style="cursor: pointer" @click="columnSort(index, 'reportSpecialists')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': sortMode && index === idx, 'text-black': index === idx}"></i></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in reportSpecialists.data">
                                <td v-for="(hdr, index) in reportSpecialists.header">
                                    {{item.values[index]}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import ReportSpecialistsFilter from "./ReportSpecialistsFilter";
  import Api from '../api/serviceproviders';
  import ReportOrgCapacityFilter from "./ReportOrgCapacityFilter";
  import Constants from "../../../common/constants";
  export default {
    name: "ReportServiceProviders",
    components: {ReportOrgCapacityFilter, ReportSpecialistsFilter, PageHeader},
    data() {
      return {
        activeItem: 'tabOrgCapacities',
        orgCapacityRptFilter: {
          dateFrom: null,
          dateTo: null,
          kindActivityId: [],
          organizationTypeIds: [],
          opfIds: [],
          districtIds: [],
          organizationIds: [],
          includeRefusals: true,
          fields: []
        },
        specialistsRptFilter: {
          dateFrom: null,
          dateTo: null,
          districtIds: [],
          organizationTypeIds: [],
          organizationIds: [],
          specialistPlanIds: [],
          specialistFactIds: [],
          fields: []
        },
        reportOrgCapacity: null,
        reportSpecialists: null,
        sortMode: false,
        idx: null,
        idxCache: null,
      }
    },
    methods: {
      isActive (menuItem) {
        return this.activeItem === menuItem
      },
      setActive (menuItem) {
        this.activeItem = menuItem
      },
      loadPage() {
        switch (this.activeItem) {
          case 'tabOrgCapacities':
            Api.getReportOrgCapacity(this.orgCapacityRptFilter)
              .then((response) => {
                this.reportOrgCapacity = response.data;
              })
              .catch(() => {
                this.showError();
              });
            break;
          case 'tabSpecialists': {
            Api.getReportSpecialists(this.specialistsRptFilter)
              .then((response) => {
                this.reportSpecialists = response.data;
              })
              .catch(() => {
                this.showError();
              });
            break;
          }
        }
      },
      onFiltersApply(filters) {
        switch (this.activeItem) {
          case 'tabOrgCapacities':
            this.orgCapacityRptFilter = filters;
            break;
          case 'tabSpecialists':
            this.specialistsRptFilter = filters;
            break;
        }
        this.loadPage();
      },
      onFiltersReset(filters) {
        switch (this.activeItem) {
          case 'tabOrgCapacities':
            this.orgCapacityRptFilter = filters || {};
            break;
          case 'tabSpecialists':
            this.specialistsRptFilter = filters || {};
            break;
        }
        this.loadPage();
      },
      exportReportOrgCapacity(filters) {
        Api.exportReportOrgCapacity(filters);
      },
      exportReportSpecialists(filters) {
        Api.exportReportSpecialists(filters);
      },
      showError() {
        Constants.alert.fire('Ошибка', 'При формировании отчета произошла ошибка. Обратитесь в техническую поддержу.', 'error');
      },
      columnSort(index, tab) {
        this.idx = index
        if(this.idxCache !== this.idx) {
          this.sortMode = false
        }
        this.idxCache = index
        let sortM = this.sortMode
        function Sort(x, y){
          if (x.values[index] < y.values[index]) {
            return sortM === true ? -1 : 1;
          }
          if (x.values[index] > y.values[index]) {
            return sortM === true ? 1 : -1;
          }
          return 0;
        }
        if(tab === "reportSpecialists") {
          this.reportSpecialists.data.sort(Sort)
        }
        if(tab === 'reportOrgCapacity') {
          this.reportOrgCapacity.data.sort(Sort)
        }
        this.sortMode = !this.sortMode
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "/src/assets/theme/default/colors.scss";
    .table-custom.special {
      tr th {
        font-size: 14px;
        padding: 8px 16px !important;
      }
    }
    .nav-tabs {
        margin-top: 20px;
        justify-content: center;
        border: none;
        .nav-item {
            max-width: 200px;
            width: 100%;
            &:not(:last-child){
                margin-right: 16px;
            }
            .nav-link {
                padding: 7.5px 17.5px;
                text-align: center;
                font-family: "Source Sans Pro", sans-serif;
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 120%;
                color: $gray-dark;
                border: 1px solid $gray-light1;
                box-sizing: border-box;
                border-radius: 6px;

                &.active {
                    color: $blue-light;
                    border: 1px solid $blue-light;
                }
            }
        }
    }

    .btn{
        border-radius: 12px;
        i{
            padding-right: 8px;
        }
    }
    .content{
        padding: 32px ;
        position: relative;
        overflow-y: visible;
        .filter{
            position: absolute;
            width: 350px;
            height: auto;
            top: 0;
            right: 0;
            overflow: hidden;
            background-color: transparent;
            opacity: 1;
            transition: opacity .2s;
        }

        .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }
        .table-custom{
            border-radius: 24px;
            background-color: $white;
            overflow: hidden;
            min-width: 100%;
            tr{
                td{
                    padding: 14px 16px;
                    border: 1px solid $gray-light1;
                    &.table-action-cell {
                        white-space: nowrap;
                    }
                }
                th{
                    padding: 20px 16px;
                    border: 1px solid $gray-light1;
                    background-color: change-color($blue-light, $alpha: 0.2);
                }
            }
            tfoot {
                font-weight: bold;
            }
        }
    }
</style>